module.exports = __webpack_public_path__ + "static/media/181CO136.02097975.jpg";